"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _validator = _interopRequireDefault(require("validator"));
var _HiTextField = _interopRequireDefault(require("./HiTextField"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent HiTextField
/**
 * Champs input email pour formulaire
 */
var HiEmailField = /*#__PURE__*/function (_React$Component) {
  function HiEmailField(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiEmailField);
    _this = _callSuper(this, HiEmailField, [props]);
    _this.handleBlur = function () {
      if (_this.props.onError && _this.props.value !== '' && !_validator.default.isEmail(_this.props.value)) {
        _this.props.onError();
      }
      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    };
    _this.handleBlur = _this.handleBlur.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiEmailField, _React$Component);
  return (0, _createClass2.default)(HiEmailField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        error = _this$props.error,
        errorText = _this$props.errorText,
        otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["error", "errorText"]);
      return /*#__PURE__*/_react.default.createElement(_HiTextField.default, (0, _extends2.default)({}, otherProps, {
        type: "email",
        error: error,
        errorText: errorText,
        onBlur: this.handleBlur
      }));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = HiEmailField;